import React from "react";
import { Button, styled, Stack, Popover, MenuItem } from "@mui/material";

export interface SelectTextInputInterface {
  title: string;
  subOptions?: { value: string; label: string }[];
  handleClick?: () => void;
  variant?: "text" | "outlined" | "contained" | undefined;
  height?: number | string;
  textColor?: string
}

const StyledButton = styled(Button)(({ theme, variant }: any) => ({
  fontWeight: 400,
  fontSize: 14,
  color: theme.palette.common.black,
  border: `1px solid ${theme.palette.common.backgroundGrey}`,
  "&:hover": {
    border:
      variant && variant === "outlined"
        ? `1px solid ${theme.palette.common.backgroundGrey}`
        : "none",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
  },
}));

const IconButtonWithText = ({
  title,
  subOptions,
  handleClick,
  variant = "outlined",
  height = 30,
  textColor = "black"
}: SelectTextInputInterface) => {
  const [anchorEl, setAnchorEl] =
    React.useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <Stack>
      <StyledButton
        variant={variant}
        style={{ height: height, color: textColor }}
        startIcon={<i className="far fa-star" style={{ fontSize: 12 }} />}
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          if (subOptions) {
            setAnchorEl(event.currentTarget);
          } else {
            if (handleClick) handleClick();
          }
        }}
        endIcon={
          subOptions && (
            <i
              className={`fal fa-chevron-down ${textColor === "white" ? "font-white" : "font-grey"}`}
              style={{ fontSize: 12 }}
            />
          )
        }
      >
        {title}
      </StyledButton>
      {subOptions && (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          PaperProps={{
            style: {
              width: anchorEl ? anchorEl.offsetWidth : 536,
            },
          }}
        >
          {subOptions.map((option: { label: string; value: string }) => (
            <MenuItem value={option.value}>{option.label}</MenuItem>
          ))}
        </Popover>
      )}
    </Stack>
  );
};

export default IconButtonWithText;
